'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

var _products = require('ifeis-isomorphic/lib/redux/selectors/products');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/registrations/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _currencies = require('../common/utils/currencies');

exports.default = function (feis, person) {
  return function (state) {

    var isRegistrationsLoading = true;

    var isPurchasedProductsLoading = true;

    var accountId = (0, _paths.getAccountForPersonId)(state, person.id);

    if (!accountId || !person.id) {
      return {
        isRegistrationsLoading: isRegistrationsLoading,
        isPurchasedProductsLoading: isPurchasedProductsLoading,
        registrationsForPerson: registrationsForPerson,
        products: [],
        accountBalances: accountBalances,
        accountPayments: accountPayments,
        feisAccountBalances: feisAccountBalances,
        cart: cart,
        eventsForFeis: [],
        registeredProductsForAccount: registeredProductsForAccount,
        account: (0, _immutable.Map)({ id: accountId }),
        longCurrency: (0, _currencies.getLongCurrency)(feis.currency),
        currencyDescription: (0, _currencies.getCurrencyDescription)(feis.currency)
      };
    }

    var accountBalances = (0, _paths.getBalancesForAccount)(state, accountId);

    var feisAccountBalances = accountBalances && accountBalances.getIn([feis.id]);

    var accountPayments = (0, _paths.getPaymentsForAccount)(state, accountId);

    var registrationsForPerson = ((0, _paths2.getRegistrationsForPerson)(state, feis.id, person.id) || (0, _immutable.List)()).map(function (eventId) {
      return (0, _paths3.getEvent)(state, eventId);
    });

    var cart = state.getIn(['feiseanna', 'carts', feis.id, 'accounts', accountId]);

    var eventsForFeis = (0, _paths3.getEvents)(state, feis.id);

    var registeredProductsForAccount = (0, _products.purchasedProductsByAccountState)(state, feis.id, accountId);

    var productIds = (0, _products.productsState)(state, feis.id);

    if (registrationsForPerson.get('loading') || !cart || !accountPayments || !accountBalances || !eventsForFeis) {
      return {
        isRegistrationsLoading: true,
        isPurchasedProductsLoading: true,
        registrationsForPerson: registrationsForPerson,
        products: [],
        accountBalances: accountBalances,
        accountPayments: accountPayments,
        feisAccountBalances: feisAccountBalances,
        cart: cart,
        eventsForFeis: (eventsForFeis || (0, _immutable.List)()).toJS(),
        registeredProductsForAccount: registeredProductsForAccount,
        account: (0, _immutable.Map)({ id: accountId }),
        longCurrency: (0, _currencies.getLongCurrency)(feis.currency),
        currencyDescription: (0, _currencies.getCurrencyDescription)(feis.currency)
      };
    }

    var products = (0, _products.productsState)(state, feis.id).map(function (product_id) {
      var p = (0, _products.getOneProduct)(state, product_id);
      return p;
    });

    return {
      isRegistrationsLoading: false,
      isPurchasedProductsLoading: false,
      registrationsForPerson: registrationsForPerson,
      products: (products || (0, _immutable.List)()).toJS(),
      accountBalances: accountBalances,
      accountPayments: accountPayments,
      feisAccountBalances: feisAccountBalances,
      cart: cart,
      eventsForFeis: (eventsForFeis || (0, _immutable.List)()).toJS(),
      registeredProductsForAccount: registeredProductsForAccount,
      account: (0, _immutable.Map)({ id: accountId }),
      longCurrency: (0, _currencies.getLongCurrency)(feis.currency),
      currencyDescription: (0, _currencies.getCurrencyDescription)(feis.currency)
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./registrations-products-sidenav/mapStateToController.js
// module id = 504
// module chunks = 0